import { useCurrentDate, Icon } from "@sellar-io/components";
import { Badge } from "../../../components/badge/Badge";
import { StorefrontAvailabilityGetResponseType } from "@sellar-io/api-v2/types";
import { getDropStatus } from "@sellar-io/common";
import dayjs from "dayjs";

export const ProductCategoryAvailabilityBadge = ({
  storefrontAvailability,
}: {
  storefrontAvailability: StorefrontAvailabilityGetResponseType;
}) => {
  const currentDate = useCurrentDate();
  const dropStatus = getDropStatus(currentDate, storefrontAvailability);

  if (dropStatus === "prelaunch") {
    return (
      <Badge className="flex w-fit items-center gap-1 font-bold">
        <Icon icon={"CIRCLE"} color={"orange"} size={0.7} />
        Releases {dayjs(storefrontAvailability.startDate).format("DD/MM/YY")}
      </Badge>
    );
  }

  if (dropStatus === "ended") {
    return (
      <Badge className="flex w-fit items-center gap-1 font-bold">
        <Icon icon={"CIRCLE"} color={"red"} size={0.7} />
        Ended {dayjs(storefrontAvailability.endDate).format("DD/MM/YY")}
      </Badge>
    );
  }

  return null;
};
